import { ApolloClient } from '@apollo/client'

import { setLocalStorageState } from '../../../hooks/useStorage'

/**
 * Drop the cart an order consumed: a signed-in shopper's cached cart, so the next read fetches the
 * new one, or a guest's stored cart id, so a new guest cart is made.
 */
export const clearOrderedCart = (
  client: ApolloClient<unknown>,
  token: string | undefined,
): void => {
  if (token) {
    client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'customerCart' })
    client.cache.gc()
  } else {
    setLocalStorageState('guest_cart_id', null)
  }
}
